import isEmpty from 'lodash/isEmpty';
import isUndefined from 'lodash/isUndefined';
import find from 'lodash/find';
import Head from 'next/head';
import dynamic from 'next/dynamic';
import styled from 'styled-components';
import { NextSeo } from 'next-seo';
import { GetServerSideProps } from 'next';
import { DATALAYER_TYPE, sendDataLayerGlobal } from 'src/utils/datalayer/send-datalayer';
import { GET, GET_ARTICLES } from 'src/utils/service';
import { APP_URL, APP_IMG } from 'src/constants';
import { timestamp } from 'src/utils/helper';
import { convertDatasets } from 'src/utils/datasets';
import ReactPlayer from 'react-player';
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { WEB_NAME } from 'src/constants/layout';
import { useMobilePhone } from 'src/utils/device';
import useUser from 'src/utils/useUser';
import { decryptionClient } from 'src/services/member-auth/utils/decryption-payload';
const PageError = dynamic(import('pages/404'));

const LayoutTPPA = dynamic(import('src/components/sections/section-events/tppa2023/layout'), { ssr: true });
const CardOverlay = dynamic(import('src/components/cards/card-overlay'));
const CardV = dynamic(import('src/components/cards/card-v'));

const Eventtppa = ({ data, articles, uriPath }: any) => {
  const _data = useUser();
  const sessionSevId = _data?.user ? decryptionClient(_data?.user) : null;
  if (isEmpty(data)) return <PageError sessionSevId={sessionSevId} />;
  const router = useRouter();
  useEffect(() => {
    document.getElementById('__next')?.classList?.remove('show-landing-page');
    document.getElementById('truehits_div')?.setAttribute('style', 'display:flex;');
  }, []);

  return (
    <>
      <NextSeo
        noindex={true}
        nofollow={true}
        title={'PEOPLE OF TOMORROW - The People'}
        description={
          convertDatasets(data[0], 'รายละเอียด', true) ||
          'เพราะอนาคตข้างหน้าเต็มไปด้วยความไม่แน่นอน และมีความเปลี่ยนแปลงใหม่ ๆ เกิดขึ้นอย่างรวดเร็วในทั่วทุกมุมโลก เราจึงต้องเตรียมพร้อมปรับตัวให้เร็วยิ่งกว่า'
        }
      />
      <Head>
        <link rel='canonical' href={`${APP_URL}/tppa2023`} />
        {/* --------------------------------- Truehit -------------------------------- */}
        <script
          type='text/javascript'
          dangerouslySetInnerHTML={{
            __html: `tppa2023";
              `
          }}
        />
      </Head>
      <LayoutTPPA sessionSevId={sessionSevId}>
        {data.map((item: any, index: number) => {
          return (
            <SectionWrapper key={index} id={`${index + 1}`} background={`${convertDatasets(item, 'background-image', true) || ''}`}>
              {index === 0 && (
                <>
                  {!isEmpty(item) && (
                    <div className='block-1 container'>
                      <div className='left'>
                        {!isUndefined(convertDatasets(item, 'img-1', true)) && (
                          <div className='img-scale-animate'>
                            <img src={`${convertDatasets(item, 'img-1', true) || ''}`} alt={`${convertDatasets(data[0], 'title-1', true)}`} width='100%' height='100%' />
                          </div>
                        )}
                      </div>
                      <div className='right'>
                        <div className='header-logo-menu'>
                          <a
                            href='/'
                            //! DATALAYER
                            onClick={() =>
                              sendDataLayerGlobal({
                                type: DATALAYER_TYPE.TRACK,
                                router: router?.pathname,
                                section: 'header',
                                data: {
                                  title: 'logo',
                                  heading: 'logo'
                                }
                              })
                            }
                          >
                            <img src={`${APP_IMG}/images/logo.png`} alt={WEB_NAME} title={WEB_NAME} width='100%' height='100%' />
                          </a>
                        </div>

                        <div className='block1-title'>
                          {item?.map((el: any, indexItem: any) => (
                            <>
                              {!isUndefined(convertDatasets(item, `title-${indexItem + 1}`, true)) && (
                                <div className={`block1-text text-${indexItem + 1}`}>{convertDatasets(item, `title-${indexItem + 1}`, true)} </div>
                              )}
                            </>
                          ))}
                        </div>
                      </div>
                      {!isUndefined(convertDatasets(item, 'background-image', true)) && (
                        <div className='img-background'>
                          <img src={`${convertDatasets(item, 'background-image', true) || ''}`} width='100%' height='100%' />
                        </div>
                      )}
                    </div>
                  )}
                </>
              )}
              {index === 1 && (
                <>
                  {!isEmpty(item) && (
                    <div className='block-2'>
                      <div className='block2-header'>
                        <div className='left'>
                          <div className={'block2-text-title'}>{convertDatasets(item, 'title-1', true) || ''} </div>
                          <div className={'block2-text-title'}>{convertDatasets(item, 'title-2', true) || ''} </div>
                          <div className={'block2-text-title'}>{convertDatasets(item, 'title-3', true) || ''} </div>
                        </div>
                        <div className='right'>
                          <div className={'block2-text-detail'}>{convertDatasets(item, 'detail-1', true) || ''} </div>
                        </div>
                      </div>
                      <div className='block2-detail'>
                        <div className='card-list'>
                          <div className='image-speakers' key={'Speakers-1'}>
                            {useMobilePhone() && <img src={convertDatasets(item, 'img-mobile', true) || ''} alt={'image'} width='100%' height='100%' />}
                            {!useMobilePhone() && <img src={convertDatasets(item, 'img-desktop', true) || ''} alt={'image'} width='100%' height='100%' />}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </>
              )}
              {index === 2 && (
                <>
                  {!isEmpty(item) && (
                    <div className='block-3'>
                      <div className='block3-header'>
                        <div className='left'>
                          <div className={'block3-text-title'}>{convertDatasets(item, 'title-1', true) || ''} </div>
                          <div className={'block3-text-title'}>{convertDatasets(item, 'title-2', true) || ''} </div>
                        </div>

                        <div className='right'>
                          <div className={'block3-text-detail'}>{convertDatasets(item, 'detail-1', true) || ''} </div>
                        </div>
                      </div>
                      {convertDatasets(item, 'VDO', true) && (
                        <div className='video'>
                          <ReactPlayer width='100%' height='100%' url={convertDatasets(item, 'VDO', true) || '#'} controls={true} />
                        </div>
                      )}
                    </div>
                  )}
                </>
              )}
              {index === 3 && (
                <>
                  {!isEmpty(item) && (
                    <div id='COMMITTEE' className='block-4'>
                      <div className='block-4-container'>
                        <h3>{convertDatasets(item, 'title-1', true) || ''}</h3>
                        <div className='card-list'>
                          {data[3].map((itemThree: any, indexThree: any) => (
                            <>
                              {indexThree > 0 && itemThree.key.indexOf('title') === -1 && itemThree.value && (
                                <div className='image-committee' key={`Committee-${indexThree}`}>
                                  <img src={itemThree.value} alt={itemThree.key} width='100%' height='100%' />
                                  <p className='text-name'> {itemThree.key || ''}</p>
                                </div>
                              )}
                            </>
                          ))}

                          {/* ))} */}
                        </div>
                      </div>
                    </div>
                  )}
                </>
              )}
              {index === 4 && (
                <>
                  {!isEmpty(item) && (
                    <div id='FINALISTS' className='block-5'>
                      <div className='block-5-container'>
                        <h3>{convertDatasets(item, 'title-1', true) || ''}</h3>
                        <div className='card-list'>
                          {data[4].map((itemFour: any, indexFour: any) => (
                            <>
                              {indexFour > 0 && itemFour.key.indexOf('title') === -1 && itemFour.value && (
                                <div className='image-finalists' key={`Finalists-${indexFour}`}>
                                  <img src={itemFour.value} alt={itemFour.key} width='100%' height='100%' />
                                  <p className='text-name'> {itemFour.key || ''}</p>
                                </div>
                              )}
                            </>
                          ))}
                        </div>
                      </div>
                    </div>
                  )}
                </>
              )}
              {index === 5 && (
                <>
                  {!isEmpty(item) && (
                    <div id='PEOPLE' className='block-red'>
                      <div className='block-red-container'>
                        <h3>{convertDatasets(item, 'title-1', true) || ''}</h3>
                        <div className='card-list'>
                          {data[5].map((itemFive: any, indexFive: any) => (
                            <>
                              {indexFive > 0 && itemFive.key.indexOf('title') === -1 && (
                                <div className='image-speakers' key={`Speakers-${indexFive}`}>
                                  <img src={itemFive.value} alt={itemFive.key} width='100%' height='100%' />
                                  <p className='text-name'> {itemFive.key || ''}</p>
                                </div>
                              )}
                            </>
                          ))}
                        </div>
                      </div>
                    </div>
                  )}
                </>
              )}

              {index === 6 && (
                <>
                  {!isEmpty(item) && (
                    <div id='BRAND' className='block-red'>
                      <div className='block-red-container'>
                        <h3>{convertDatasets(item, 'title-1', true) || ''}</h3>
                        <div className='card-list'>
                          {data[6].map((itemSix: any, indexSix: any) => (
                            <>
                              {indexSix > 0 && itemSix.key.indexOf('title') === -1 && itemSix.value && (
                                <div className='image-speakers' key={`Speakers-${indexSix}`}>
                                  <img src={itemSix.value} alt={itemSix.key} width='100%' height='100%' />
                                  <p className='text-name'> {itemSix.key || ''}</p>
                                </div>
                              )}
                            </>
                          ))}
                        </div>
                      </div>
                    </div>
                  )}
                </>
              )}
              {index === 7 && (
                <>
                  {!isEmpty(item) && !isEmpty(articles) && (
                    <div id='PARTNERS' className='block-7'>
                      <div className='block-7-container'>
                        <div className='block-7-header'>{convertDatasets(item, 'title-1', true) || ''}</div>
                        <>
                          {articles?.slice(0, 1).map((item: any, index: any) => (
                            <>
                              <div key={index}>
                                {index === 0 && (
                                  <>
                                    <CardOverlay
                                      data={item}
                                      showTitle={true}
                                      showBlurb={false}
                                      showByline={false}
                                      showTime={false}
                                      external={false}
                                      className={'tppa-showtitle'}
                                      //! DATALAYER
                                      eventDataLayer={{
                                        type: DATALAYER_TYPE.TRACK_INDEX,
                                        router: router?.pathname,
                                        data: {
                                          block: '7',
                                          title: item?.title,
                                          heading: item?.subCategory?.en,
                                          index: '1'
                                        }
                                      }}
                                    />
                                  </>
                                )}{' '}
                                <></>
                              </div>
                            </>
                          ))}
                          <div key={index} className={'card-list'}>
                            {articles?.slice(1, 4).map((item: any, index: any) => (
                              <div className={`card-${index}`}>
                                <CardV
                                  data={item}
                                  showTitle={true}
                                  showBlurb={false}
                                  showByline={false}
                                  showTime={false}
                                  showCountview={false}
                                  external={false}
                                  //! DATALAYER
                                  eventDataLayer={{
                                    type: DATALAYER_TYPE.TRACK_INDEX,
                                    router: router?.pathname,
                                    data: {
                                      block: '7',
                                      title: item?.title,
                                      heading: item?.subCategory?.en,
                                      index: index + 1
                                    }
                                  }}
                                />
                              </div>
                            ))}
                          </div>
                          <a className='more' href={`${APP_URL}/${uriPath}`} title={''}>
                            <p className={'active text-left '}>ดูทั้งหมด</p>
                          </a>
                        </>
                      </div>
                    </div>
                  )}
                </>
              )}
              {index === 8 && (
                <>
                  {!isEmpty(item) && (
                    <div id='SPONSORS' className='block-8'>
                      <div className='block-8-container'>
                        <h3>{convertDatasets(item, 'title-1', true) || ''}</h3>
                        <div className='card-list'>
                          {data[8].map((itemSeven: any, indexSeven: any) => (
                            <div>
                              {indexSeven > 0 && itemSeven.key.indexOf('title') === -1 && itemSeven.value && (
                                <div className='image-sponsors' key={`sponsors-${indexSeven}`}>
                                  <img src={itemSeven.value} alt={itemSeven.key} width='100%' height='100%' />
                                </div>
                              )}
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  )}
                </>
              )}
              {index === 9 && (
                <>
                  {!isEmpty(item) && (
                    <div id='PARTNERS' className='block-9'>
                      <div className='block-9-container'>
                        <h3>{convertDatasets(item, 'title-1', true) || ''}</h3>
                        <div className='card-list'>
                          {data[9].map((itemSeven: any, indexSeven: any) => (
                            <div>
                              {indexSeven > 0 && itemSeven.key.indexOf('title') === -1 && itemSeven.value && (
                                <div className='image-partners' key={`Partners-${indexSeven}`}>
                                  <img src={itemSeven.value} alt={itemSeven.key} width='100%' height='100%' />
                                </div>
                              )}
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  )}
                </>
              )}
            </SectionWrapper>
          );
        })}
      </LayoutTPPA>
    </>
  );
};

export const getServerSideProps: GetServerSideProps = async ({ req, res }) => {
  const initProps: any = {
    statusCode: 200,
    errMessage: null,
    data: [],
    topic: '',
    articles: {},
    uriPath: ''
  };

  try {
    /* --------------------------------- DATASET -------------------------------- */
    const fetchDataSet = await GET('/api/datasets');

    /* --------------------------------- tppa -------------------------------- */
    const topic = 'tppa';
    const dataObj = [];
    const dataLength = 10;
    let resData = [];
    let tag = [];
    let keysTag = '';
    if (!isEmpty(fetchDataSet)) {
      for (let i = 1; i <= dataLength; i++) {
        const tppa = (!isEmpty(fetchDataSet) && find(fetchDataSet, { topic: 'tppa-' + i })?.dataSet) || [];
        dataObj[i - 1] = tppa;
        if (i === 8) {
          let keys = convertDatasets(tppa, 'keys', true);
          const link = convertDatasets(tppa, 'link', true);
          initProps.uriPath = `${convertDatasets(tppa, 'keys', true)}${link}` || '';

          if (keys === 'category') {
            keys = 'categories';
          } else if (keys === 'tag') {
            if (link.indexOf('/') !== -1) {
              tag = link.split('/');
              keysTag = tag[1];
            } else {
              keysTag = link;
            }
          }
          const uri = `${keys}${link}`;
          if (keys === 'tag') {
            resData = await GET_ARTICLES(`/api/search/tag?name=${keysTag}`, false, true);
          } else if (keys === 'categories') {
            resData = await GET_ARTICLES(`/api/v1.0/${uri}`, false, true);
          }

          initProps.articles = resData?.data || [];
        }
      }

      initProps.data = dataObj;
      initProps.topic = topic;
    }
  } catch (err: any) {
    console.error(`${timestamp()} ==========> OPEN_HOUSE ERROR : `, err.message);
    initProps.errMessage = err.message;
    initProps.statusCode = err?.response?.status || 500;
  }

  return {
    props: initProps
  };
};

export default Eventtppa;

const SectionWrapper: any = styled.section<{
  size: any;
  background: any;
}>`
  position: relative;
  overflow: hidden;
  display: block;
  width: 100%;
  margin: 0;
  padding: unset;
  /* padding: 15px 0px; */
  .img-scale-animate {
    z-index: 1;
    position: relative;
    /* aspect-ratio: 4/3; */
    max-width: 100%;
    width: 100%;
    img {
      max-width: 100%;
      width: 100%;

      @media (max-width: 1024px) {
        width: 80%;
      }
      @media (max-width: 767px) {
        width: 50%;
      }
    }
  }

  .block-1 {
    padding: 30px 30px;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-areas:
      'left right'
      'img-background img-background';
    grid-gap: 20px;
    width: 1300px;
    max-width: 100%;
    margin: auto;
    aspect-ratio: 16/9;
    padding: 30px 0;
    width: 100%;
    max-width: 100%;
    position: relative;

    .img-background {
      width: 100%;
      position: absolute;
      bottom: 0;
      height: 180px;
      z-index: -1;
      @media (max-width: 1024px) {
        height: 130px;
      }
      @media (max-width: 425px) {
        top: 30%;
      }
    }
    @media (max-width: 767px) {
      grid-template-columns: 1fr;
      display: block;
    }

    .header-logo-menu {
      text-align: center;
      height: 100px;
      max-height: 100%;
      @media (max-width: 767px) {
        display: block;
        margin-left: auto;
        margin-right: auto;
      }
      h1 {
        margin: 0;
        overflow: hidden;
        position: relative;
        @media (max-width: 480px) {
          display: flex;
          align-items: center;
        }

        span {
          text-indent: 1000em;
          white-space: nowrap;
          overflow: hidden;
          display: block;
          position: absolute;
          width: 100%;
        }
      }
      img {
        width: 300px;
        max-width: 100%;
      }
    }
    .left {
      grid-area: left;
      width: 200px;
      max-width: 100%;
      display: block;
      margin-left: auto;
      margin-right: auto;
      text-align: center;
      /* @media (max-width: 690px) {
        display: none;
      } */
    }
    .right {
      width: max-content;
      grid-area: right;
      padding-right: 70px;
      display: block;
      grid-gap: 20px;
      @media (max-width: 767px) {
        width: unset;
        padding-right: unset;
        grid-area: unset;
      }
      .block1-title {
        line-height: 1;
        text-align: center;
        margin-top: 20px;
        color: #3d3d3d;
        .block1-text {
          font-weight: 700;
          &.text-1,
          &.text-2,
          &.text-3 {
            font-size: 85px;
            @media (max-width: 1024px) {
              font-size: 72px;
            }
            @media (max-width: 690px) {
              font-size: 48px;
            }
            @media (max-width: 320px) {
              font-size: 36px;
            }
          }
          &.text-4 {
            font-size: 48px;
            @media (max-width: 1024px) {
              font-size: 42px;
            }
            @media (max-width: 690px) {
              font-size: 36px;
            }
            @media (max-width: 320px) {
              font-size: 28px;
            }
          }
          &.text-5,
          &.text-6 {
            font-size: 32px;
            line-height: 1.75;
            @media (max-width: 1024px) {
              font-size: 20px;
            }
            @media (max-width: 690px) {
              font-size: 18px;
            }
            @media (max-width: 320px) {
              font-size: 14px;
            }
          }
          &.text-6 {
            padding-top: 5px;
          }
        }
      }

      h2 {
        font-size: 28px;
        font-weight: 400;
        @media (max-width: 768px) {
          font-size: 22px;
        }
      }
      p {
        font-size: 24px;
        font-weight: 400;
        @media (max-width: 768px) {
          font-size: 18px;
        }
        @media (max-width: 768px) {
          font-size: 16px;
          font-weight: 300;
        }
      }
    }
  }
  .block-2 {
    width: 1300px;
    max-width: 100%;
    margin: auto;
    padding: 30px 0px;
    .block2-header {
      //padding: 15px 15px;
      justify-content: space-between;
      display: flex;

      @media (max-width: 1024px) {
        padding-left: 25px;
        padding-right: 25px;
      }
      @media (max-width: 768px) {
        padding-left: 15px;
        padding-right: 15px;
      }
      @media (max-width: 425px) {
        display: block;
        text-align: center;
      }
      .block2-text-title {
        font-size: 52px;
        font-weight: 700;
        line-height: 1.2;
        color: #ea1b3c;
        @media (max-width: 767px) {
          font-size: 48px;
        }
        @media (max-width: 1024px) {
          font-size: 36px;
          min-width: 250px;
        }
        @media (max-width: 767px) {
          font-size: 32px;
        }
      }
      .block2-text-detail {
        font-size: 22px;
        max-width: 600px;
        width: 100%;
        font-weight: 200;

        @media (max-width: 1024px) {
          font-size: 16px;
        }
        @media (max-width: 767px) {
          font-size: 14px;
        }
        @media (max-width: 425px) {
          padding-top: 10px;
        }
      }
    }
    .block2-detail {
      .card-list {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        padding-top: 30px;
        .image-speakers {
          width: 100%;
          max-width: 1200px;
          object-fit: cover;
          text-align: center;
          object-position: center;
          padding: 15px;
          width: 100%;

          @media (max-width: 425px) {
            max-width: 450px;
            width: 100%;
            aspect-ratio: 1/1;
            padding: 10px;
          }
          p {
            color: #ff8345;
            text-align: center;
            font-size: 18px;
            font-weight: 700;
            @media (max-width: 690px) {
              font-size: 16px;
            }
          }
          img {
            max-width: 100%;
            object-fit: cover;
          }
        }
      }
    }
  }
  .block-3 {
    width: 1300px;
    max-width: 100%;
    margin: auto;
    padding-bottom: 50px;

    .block3-header {
      padding: 0 15px;
      padding-bottom: 30px;
      justify-content: space-between;
      display: flex;
      @media (max-width: 1024px) {
        padding-left: 25px;
        padding-right: 25px;
      }
      @media (max-width: 768px) {
        padding-left: 15px;
        padding-right: 15px;
      }
      @media (max-width: 425px) {
        display: block;
        text-align: center;
      }
      .block3-text-title {
        font-size: 52px;
        font-weight: 700;
        line-height: 1.2;
        color: #ea1b3c;
        @media (max-width: 767px) {
          font-size: 48px;
        }
        @media (max-width: 1024px) {
          font-size: 36px;
          min-width: 250px;
        }
        @media (max-width: 767px) {
          font-size: 32px;
        }
      }
      .block3-text-detail {
        font-size: 22px;
        max-width: 600px;
        width: 100%;
        font-weight: 200;

        @media (max-width: 1024px) {
          font-size: 16px;
        }
        @media (max-width: 767px) {
          font-size: 14px;
        }
        @media (max-width: 425px) {
          padding-top: 10px;
        }
      }
    }

    .video {
      padding-top: 15px;

      grid-area: video;
      width: 70%;
      margin-left: 15%;
      aspect-ratio: 16/9;
    }
  }
  .block-4 {
    background-color: #ea1b3c;
    .block-4-container {
      width: 1300px;
      max-width: 100%;
      margin: auto;
      padding: 30px 15px;

      h3 {
        font-size: 56px;
        text-align: center;
        color: #ffffff;
        padding-bottom: 15px;
        @media (max-width: 768px) {
          font-size: 3rem;
        }
        @media (max-width: 690px) {
          font-size: 2rem;
        }
      }
    }
    .card-list {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      padding-bottom: 30px;
      .card-item {
        width: 25%;
        text-align: center;
        margin-bottom: 30px;
        aspect-ratio: 1/1;
        padding: 15px;
        @media (max-width: 768px) {
          width: 50%;
          margin-bottom: 0px;
        }
      }
      .image-committee {
        padding: 30px;
        max-width: 260px;
        width: 100%;
        max-height: 260px;
        @media (max-width: 425px) {
          max-width: 190px;
          max-height: 190px;
          padding: 25px;
        }
        @media (max-width: 375px) {
          max-width: 170px;

          max-height: 170px;
        }
        @media (max-width: 320px) {
          max-width: 140px;
          max-height: 140px;
        }

        .text-name {
          color: #ffffff !important;
          font-weight: 400 !important;
          text-align: center;
        }
        p {
          color: #fff;
          text-align: center;
          font-size: 22px;
          font-weight: 700;
          text-align: center;
          padding-top: 5px;
          line-height: 1;
          @media (max-width: 768px) {
            font-size: 16px;
          }
          @media (max-width: 425px) {
            font-size: 14px;
          }
          @media (max-width: 320px) {
            padding-top: unset;
          }
        }
        img {
          max-width: 100%;
          object-fit: cover;
          border-radius: 50%;
        }
      }
    }
  }
  .block-5 {
    .block-5-container {
      width: 1300px;
      max-width: 100%;
      margin: auto;
      padding: 30px 15px;

      .text-name {
        padding-top: 10px;
        font-weight: 400 !important;
      }
      h3 {
        font-size: 52px;
        text-align: center;
        color: #ea1b3c;
        padding-bottom: 15px;
        /* padding: 30px 0; */

        @media (max-width: 768px) {
          font-size: 3rem;
        }
        @media (max-width: 690px) {
          font-size: 2rem;
        }
      }
    }
    .card-list {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      .image-finalists {
        text-align: center;
        padding: 25px;

        max-width: 200px;
        max-height: 200px;
        line-height: 1;
        @media (max-width: 425px) {
          max-width: 190px;
          max-height: 190px;
        }
        @media (max-width: 375px) {
          max-width: 170px;
          max-height: 170px;
        }
        @media (max-width: 320px) {
          max-width: 140px;
          max-height: 140px;
        }
        p {
          color: #000000;
          text-align: center;
          font-size: 18px;
          font-weight: 700;
          @media (max-width: 768px) {
            font-size: 16px;
          }
          @media (max-width: 425px) {
            font-size: 14px;
          }
          @media (max-width: 320px) {
            padding-top: unset;
          }
        }
        img {
          max-width: 100%;
          object-fit: cover;
          border-radius: 50%;
        }
      }
    }
  }
  .block-red {
    background-color: #ea1b3c;

    .block-red-container {
      width: 1300px;
      max-width: 100%;
      margin: auto;
      padding: 30px 15px;
      h3 {
        font-size: 52px;
        text-align: center;
        color: #ffffff;
        padding-bottom: 15px;

        @media (max-width: 768px) {
          font-size: 3rem;
        }
        @media (max-width: 690px) {
          font-size: 2rem;
        }
      }
    }
    .card-list {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      .image-speakers {
        text-align: center;
        margin-bottom: 10px;
        padding: 25px;
        max-width: 220px;
        max-height: 220px;

        @media (max-width: 425px) {
          max-width: 190px;
          max-height: 190px;
        }
        @media (max-width: 375px) {
          max-width: 170px;
          max-height: 170px;
        }
        @media (max-width: 320px) {
          max-width: 140px;
          max-height: 140px;
          padding: 15px;
        }
        p {
          color: #ffffff;
          text-align: center;
          font-size: 18px;
          font-weight: 400;
          padding-top: 5px;
          line-height: 1;
          @media (max-width: 768px) {
            font-size: 16px;
          }
          @media (max-width: 425px) {
            font-size: 14px;
          }
          @media (max-width: 320px) {
            padding-top: unset;
          }
        }
        img {
          max-width: 100%;
          object-fit: cover;
          border-radius: 50%;
        }
      }
    }
  }
  .block-7 {
    .block-7-container {
      width: 1300px;
      max-width: 100%;
      margin: auto;
      padding: 0 15px;
      padding-bottom: 30px;
      .text-name {
        padding-top: 10px;
        font-weight: 400 !important;
      }
      .block-7-header {
        font-size: 52px;
        text-align: center;
        color: #000;
        padding: 30px 0;
        font-weight: 700;
        @media (max-width: 768px) {
          font-size: 3rem;
        }
        @media (max-width: 690px) {
          font-size: 2rem;
        }
      }
    }
    .card-list {
      grid-template-columns: repeat(3, 1fr);
      display: grid;
      grid-gap: 10px;

      .lg-react-element {
        display: contents;
      }
      @media (max-width: 425px) {
        grid-template-columns: repeat(2, 1fr);
      }
      .card-2 {
        @media (max-width: 425px) {
          display: none;
        }
      }
    }

    .img-scale-animate {
      .resolution-image {
        img {
          width: 100%;
        }
      }
    }
    .text-left {
      font-size: 16px;
      padding: 2px 10px;
      background-color: rgb(220 21 53);
      color: #fff;
      border-radius: 8px;
      white-space: nowrap;

      &:hover {
        color: #ed1a3b;
        background-color: rgb(255, 255, 255);
      }
    }
    .more {
      justify-content: flex-end;
      display: flex;
      padding-top: 15px;
    }
  }
  .block-8 {
    .block-8-container {
      width: 1300px;
      max-width: 100%;
      margin: auto;
      padding: 0 15px;
      padding-bottom: 30px;

      .text-name {
        padding-top: 10px;
        font-weight: 400 !important;
      }
      h3 {
        font-size: 52px;
        text-align: center;
        color: #000;
        padding: 30px 0;

        @media (max-width: 768px) {
          font-size: 3rem;
        }
        @media (max-width: 690px) {
          font-size: 2rem;
        }
      }
    }
    .card-list {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;

      .image-sponsors {
        aspect-ratio: 1/1;
        /* max-width: 20%; */
        text-align: center;

        padding: 10px;
        width: 100%;
        height: 100%;
        max-width: 150px;
        max-height: 150px;

        @media (max-width: 480px) {
          max-width: 130px;
          max-height: 130px;
        }
        @media (max-width: 420px) {
          max-width: 110px;
          max-height: 110px;
        }
        @media (max-width: 375px) {
          max-width: 105px;
          max-height: 105px;
        }

        @media (max-width: 344px) {
          max-width: 80px;
          max-height: 80px;
        }
        p {
          color: #000000;
          text-align: center;
          font-size: 18px;
          font-weight: 700;
          @media (max-width: 768px) {
            font-size: 16px;
          }
          @media (max-width: 375px) {
            font-size: 14px;
          }
        }
        img {
          max-width: 100%;
          object-fit: cover;
          border-radius: 50%;
        }
      }
    }
  }
  .block-9 {
    .block-9-container {
      width: 1300px;
      max-width: 100%;
      margin: auto;
      padding: 0 15px;
      padding-bottom: 30px;

      .text-name {
        padding-top: 10px;
        font-weight: 400 !important;
      }
      h3 {
        font-size: 52px;
        text-align: center;
        color: #000;
        padding: 30px 0;

        @media (max-width: 768px) {
          font-size: 3rem;
        }
        @media (max-width: 690px) {
          font-size: 2rem;
        }
      }
    }
    .card-list {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      padding-left: 100px;
      padding-right: 100px;
      @media (max-width: 768px) {
        padding-left: unset;
        padding-right: unset;
      }
      /* @media (max-width: 480px) {
        padding-left: 70px;
        padding-right: 70px;
      } */

      /* @media (max-width: 425px) {
        padding-left: 50px;
        padding-right: 50px;
      } */
      .image-partners {
        aspect-ratio: 1/1;
        /* max-width: 20%; */
        text-align: center;

        padding: 10px;
        width: 100%;
        height: 100%;
        max-width: 120px;
        max-height: 120px;

        @media (max-width: 510px) {
          max-width: 100px;
          max-height: 100px;
          padding: 5px;
        }
        @media (max-width: 480px) {
          max-width: 95px;
          max-height: 95px;
          padding: 5px;
        }
        @media (max-width: 425px) {
          max-width: 90px;
          max-height: 900px;
        }
        @media (max-width: 375px) {
          max-width: 80px;
          max-height: 80px;
        }
        @media (max-width: 350px) {
          max-width: 65px;
          max-height: 65px;
        }
        p {
          color: #000000;
          text-align: center;
          font-size: 18px;
          font-weight: 700;
          @media (max-width: 768px) {
            font-size: 16px;
          }
          @media (max-width: 375px) {
            font-size: 14px;
          }
        }
        img {
          max-width: 100%;
          object-fit: cover;
          border-radius: 50%;
        }
      }
    }
  }
`;
